import { defineComponent as _defineComponent } from 'vue';
import { curveCatmullRom, curveLinear, line } from "d3";
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import { vecSubtract } from "../modules/geometry";
import { colors } from "./colors";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FreehandComment',
    props: {
        comment: null
    },
    emits: ["remove"],
    setup(__props, { emit }) {
        const props = __props;
        const linear = line().curve(curveLinear);
        const catmullRom = line().curve(curveCatmullRom);
        const { commentStore, toolbarStore } = useWorkflowStores();
        const curve = computed(() => {
            var _a, _b;
            if (commentStore.isJustCreated(props.comment.id)) {
                return (_a = linear(props.comment.data.line.map((p) => vecSubtract(p, props.comment.position)))) !== null && _a !== void 0 ? _a : undefined;
            }
            else {
                return (_b = catmullRom(props.comment.data.line)) !== null && _b !== void 0 ? _b : undefined;
            }
        });
        const style = computed(() => {
            const style = {
                "pointer-events": toolbarStore.currentTool === "freehandEraser" ? "stroke" : "none",
                "--thickness": `${props.comment.data.thickness}px`,
            };
            if (props.comment.color !== "none") {
                style["--color"] = colors[props.comment.color];
            }
            if (toolbarStore.inputCatcherEnabled) {
                style["cursor"] = "crosshair";
            }
            return style;
        });
        function onMouseOver() {
            if (toolbarStore.inputCatcherPressed) {
                emit("remove");
            }
        }
        function onClick() {
            if (toolbarStore.inputCatcherEnabled) {
                emit("remove");
            }
        }
        return { __sfc: true, props, emit, linear, catmullRom, commentStore, toolbarStore, curve, style, onMouseOver, onClick };
    }
});
